"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GaugePhase = GaugePhase;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _greenTick = require("../assets/green-tick.svg");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _CogManager = require("../utils/CogManager");
var _TiltGauge = _interopRequireDefault(require("../TiltGauge"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function GaugePhase(_ref) {
  let {
    nextPhase,
    BlocksConnectedIcon,
    initialBlock,
    blocksGif
  } = _ref;
  const [cogTiltValue, setCogTiltValue] = (0, _react.useState)(0);
  const [tickIconState, setTickIconState] = (0, _react.useState)("hidden");
  const [blocksIconState, setBlocksIconState] = (0, _react.useState)("visible");
  (0, _react.useEffect)(() => {
    const intervalId = setInterval(() => {
      const connectedCog = (0, _CogManager.getConnectedCog)();
      if (connectedCog) {
        // @ts-ignore remove ts ignore once you update the webapptypes -- steeringDetection is not in the types yet
        if (!connectedCog.publishedDataAnalyser.steeringDetection.isHeldAsSteeringWheelProp) {
          return;
        }
        const ay = connectedCog.raftStateInfo.accelerometer.ay;
        const ax = connectedCog.raftStateInfo.accelerometer.ax;
        const raw = Math.atan2(ay, -ax); // radians, zero=right, CCW+
        const tiltValue = raw - Math.PI / 2;
        console.log("tiltValue", tiltValue);
        // const tiltValue = display / Math.PI;
        if (blocksIconState === "visible") {
          setCogTiltValue(tiltValue);
        }
      }
    }, 200);
    return () => clearInterval(intervalId);
  }, []);
  const onBlocksAnimationEnd = (0, _react.useCallback)(() => {
    setBlocksIconState("hidden");
    setTickIconState("animation");
  }, []);
  const onTickIconAnimationEnd = (0, _react.useCallback)(() => {
    nextPhase();
  }, []);
  const blocksIconContainerClasses = [_stylesModule.default.doubleColumnContainer, blocksIconState === "animation" ? _stylesModule.default.fadeOutAnimation : "", blocksIconState === "hidden" ? _stylesModule.default.hide : ""].join(" ");
  const tickIconClassNames = [_stylesModule.default.tickIconFullScreen, tickIconState === "animation" ? _stylesModule.default.fadeInAnimation : "", tickIconState === "hidden" ? _stylesModule.default.hide : "", tickIconState === "visible" ? _stylesModule.default.show : ""].join(" ");
  let cogTiltValue_ = cogTiltValue > 1.4 ? 1.4 : cogTiltValue < -1.4 ? -1.4 : cogTiltValue;
  // cogTiltValue_ range is from -1.4 to 1.4, convert to 0-1 range
  if (initialBlock.block === "tiltleft") {
    // Map 0 to -1.4 => 0 to 1
    cogTiltValue_ = -cogTiltValue / 1.4;
    if (cogTiltValue > 0) {
      cogTiltValue_ = 0;
    }
  } else if (initialBlock.block === "tiltright") {
    // Map 0 to 1.4 => 0 to 1
    cogTiltValue_ = cogTiltValue / 1.4;
    if (cogTiltValue < 0) {
      cogTiltValue_ = 0;
    }
  }
  if (cogTiltValue_ > 1) {
    cogTiltValue_ = 1;
  } else if (cogTiltValue_ < 0) {
    cogTiltValue_ = 0;
  }
  if (cogTiltValue_ > 0.95) {
    if (blocksIconState === "visible") {
      setBlocksIconState("animation");
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.singleColumnContainer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: blocksIconContainerClasses,
      onAnimationEnd: onBlocksAnimationEnd,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.blocksGifContainer,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: blocksGif,
          alt: "Blocks Gif",
          className: _stylesModule.default.blocksGif
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.gaugeContainer,
        style: {},
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TiltGauge.default, {
          score: cogTiltValue_,
          title: ""
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_greenTick.ReactComponent, {
      className: tickIconClassNames,
      onAnimationEnd: onTickIconAnimationEnd
    })]
  });
}

// commands to generate the gifs from the videos
// ffmpeg -ss 4 -t 1.8 -i steer_left.mov -vf "fps=15,scale=320:-1:flags=lanczos,palettegen" palette.png

// ffmpeg -ss 4 -t 1.8 -i steer_left.mov -i palette.png -filter_complex "fps=15,scale=320:-1:flags=lanczos[x];[x][1:v]paletteuse" output.gif

// ffmpeg -ss 4 -t 1.8 -i steer_right.mov -vf "fps=15,scale=320:-1:flags=lanczos,palettegen" palette.png

// ffmpeg -ss 4 -t 1.8 -i steer_right.mov -i palette.png -filter_complex "fps=15,scale=320:-1:flags=lanczos[x];[x][1:v]paletteuse" steer_right.gif